// extracted by mini-css-extract-plugin
export default {"car_city":"index_car_city_ADPnh"};